import type { PreviewNotes } from "~types/types";

export const PREVIEW_NOTES: PreviewNotes = {
    curationName: "Feature Lede Weekend",
    description:
        "Feature Lede Weekend has support for portrait and landscape media types, it also conditionally renders a byline, authorImage and eyebrow and uses a special font treatment. Use the item's `Style` dropdown to hide byline or headshot. Update the eyebrow using the `label` dropdown or type one in.",
    links: [
        {
            name: "Figma",
            url: "https://www.figma.com/design/jxjXf8PuK2LWpiLTpgHoXk/The-Weekend-Handoff?node-id=2050-899&m=dev",
        },
    ],
};
